import React, {Component} from 'react';
import {getPreviousReportsOfProperty, loadReport,getReportById} from "../../data/report_api";
import {Form, Button, Confirm,Modal,Header,Message} from 'semantic-ui-react';
import moment from "moment";
import ReportContainer from "../../containers/report_container";
import {REPORT_ACTIONS_API_URL} from "../../constants/api_routes";
import Loader from "../universal/loader";

class LoadReport extends Component {

    constructor(props){
        super(props);
        this.state = {
            reportRooms: [],
            reportRoomName:undefined,
            isDownloading:false,
            reportListOptions:[],
            loadHasData:true,
            selectedInspection:undefined,
            imageOption:undefined,
            errorMessage:undefined,
        }
    }

    componentWillMount() {
        const inspectionStatus = {"pending":'Pending', "scheduled":'Scheduled', "confirmed":'Confirmed', "processing":'Processing', "submitted":'Submitted', "completed":'Completed', "request_abort":'Requested Abort', "aborted":'Aborted', "request_cancel":'Request Cancel', "cancelled":'Cancelled'};
        getPreviousReportsOfProperty(this.props.reportId,this.props.inspectionType).then((reportList_)=>{
            let reportList = reportList_.inspections
            let reportOptions = [{key:'00',text:'---Select Report---',value:undefined}];
            const listOptions = reportList.length;
            if(listOptions > 0){
                for (let i = 0; i < listOptions; i++) {
                    let obj = {
                        key: reportList[i]['id'],
                        text: reportList[i]['inspection_type'].toUpperCase() + " - " +reportList[i]["report_type"].toUpperCase() +  " - " + moment(reportList[i]['inspection_start_time'],"YYYY-MM-DD HH:mm:ss Z").format("LL") +" - "+inspectionStatus[reportList[i]['status']],
                        value: reportList[i]['id']
                    };
                    reportOptions.push(obj);
                }
                this.setState({reportListOptions: reportOptions});
            }
        })
    }

    checkLoadStatus = async () => {
        var data = await getReportById(REPORT_ACTIONS_API_URL, this.props.reportId);
        if (data.report.loading_report) {
            if (data.report.rooms.length > 0) {
                let lastRoomName = data.report.rooms[data.report.rooms.length - 1].name
                this.setState({ reportRooms: data.report.rooms, reportRoomName: lastRoomName })
            }   
        }
        else {
         clearInterval(this.state.intervalId);
         this.props.getReportById(REPORT_ACTIONS_API_URL, this.props.reportId,this.successCallBack);
        }
    }

    handleSubmit= () => {
        this.setState({showConfirm:false,showLoading:true});
        if(this.state.selectedInspection){
            loadReport(this.props.reportId,{"inspection_id":this.state.selectedInspection,"report_id":this.props.reportId,"image_option":this.state.imageOption}).then((response) => {
                if(response.success){
                   this.props.getReportById(REPORT_ACTIONS_API_URL, this.props.reportId,this.successCallBack);
                }
                else {
                    this.setState({showLoading:false,errorMessage:response.statusMessage});
                }
                if(this.state.intervalId) {clearInterval(this.state.intervalId);}
            });
            let intervalId = setInterval(() => this.checkLoadStatus(),20000);
            this.setState({ intervalId: intervalId });
        }
    };

    handleCancel = () => {
      this.setState({showConfirm:false,selectedInspection:undefined});
    };

    successCallBack = (response) => {
        this.setState({showLoading:false});
        this.props.close();
    };

    getConfirm = () => {
        if(this.state.selectedInspection) {
            this.setState({showConfirm: true});
        }
        else {
            this.setState({loadHasData:false});
        }
    };

    handleChange = (e, { value }) => this.setState({imageOption: parseInt(value)});

    render(){
        return(<div style={{width:'50%'}}>
            {this.state.errorMessage && this.state.errorMessage.length > 1  && <Message color='red' onDismiss={() => {this.setState({errorMessage:undefined})}}>
                <Message.Header>Oops! An error occurred while loading report</Message.Header>
                <p>{this.state.errorMessage}</p>
            </Message>}
            {this.state.showConfirm && <div>
                <Confirm open={true} header="Confirm load Report" content="All Work done so far if any will be lost on loading the new report" onCancel={this.handleCancel} onConfirm={this.handleSubmit} /></div>}
            <Modal open={this.state.showLoading} basic size='small' style={{zIndex:'100000'}}>
                <Header size="large" icon='refresh' content='Loading Report Content...' />
                <Modal.Content>
                    <p className="format-bold">
                        The selected report data is being imported into current report.
                    </p>
                    <p>
                        This might take some time. please wait...
                    </p>
                    <p>
                        Do not retry loading the report again on a different tab before this is complete, as this will lead to duplicate rooms.
                    </p>
                    <div>
                        <Loader contain customText={"Copying Data " + (this.state.reportRooms.length == 0? " - Progress will appear here soon..." : ""+ " - " + this.state.reportRoomName)}/>
                    </div>
                    <p className="center-aligned">
                        Loading...
                    </p>
                </Modal.Content>
            </Modal>
            <Form onSubmit={this.getConfirm}>
             <Form.Dropdown
                label='Load Report From'
                required
                error={!this.state.loadHasData}
                selection
                search
                noResultsMessage="No previous reports found"
                wrapSelection={false}
                options={this.state.reportListOptions}
                placeholder='Select Report to Load'
                onChange={(e, option) => {
                    this.setState({selectedInspection: option.value});
                }}
            />
                {this.props.inspectionType != "co" && <Form.Field>
                    <Form.Radio
                        label='With NO Images'
                        name='imageOption'
                        value='0'
                        checked={this.state.imageOption == '0'}
                        onChange={this.handleChange}
                    />
                </Form.Field>}
                <Form.Field>
                    <Form.Radio
                        label='With CI Images only'
                        name='imageOption'
                        value='1'
                        checked={this.state.imageOption == '1'}
                        onChange={this.handleChange}
                    />
                </Form.Field>
                {/* <Form.Field>
                    <Form.Radio
                        label='With all Images'
                        name='imageOption'
                        value='2'
                        checked={this.state.imageOption == '2'}
                        onChange={this.handleChange}
                    />
                </Form.Field> */}
                <Button type="button"content="Cancel" onClick={()=>{this.props.close()}}/>
                <Button content="Load Report" primary disabled={!this.state.selectedInspection|| this.state.imageOption==undefined} />
            </Form>
        </div>)
    }
}

export default ReportContainer(LoadReport);


// WEBPACK FOOTER //
// ./src/views/report/initialize_report_from_old_report.js